import { render, staticRenderFns } from "./RaceSeriesNews.vue?vue&type=template&id=c2f0b9da&"
import script from "./RaceSeriesNews.vue?vue&type=script&lang=js&"
export * from "./RaceSeriesNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports